import { absolutePath } from "./absolutePath";

export const communityMemberPaymentProcessor = {
  index: () => absolutePath("community_member_payment_processors"),
};
